export const _LOAD_MODEL_ = 'Load:ResellerModel';
export const _DELETE_RESELLER_ = 'Delete:Reseller';
export const _SELECTED_RESELLER_ = 'Selected:Reseller';
export const _OPEN_CONFIRMATION_ = 'Confirmation:Open';
export const _REPORT_RESELLER_LEAD_ = 'Save:ResellerLeadModal';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_RESELLER_SUCCESS_ = 'Save:ResellerSuccess';

export const ADDRESS = {
  id: null,
  city: '',
  label: 'Endereço Principal',
  state: '',
  number: '',
  street: '',
  address: '',
  country: 'BR',
  zipcode: '',
  address2: null,
  district: '',
};

export const MODEL = {
  id: null,
  lat: '',
  lng: '',
  name: '',
  email: '',
  phone: '',
  status: 1,
  premium: 0,
  viewer: 0,
  cellphone: null,
  representatives: [],
  social_medias: {
    facebook: null,
    instagram: null,
  },
  address: { ...ADDRESS },
};
